import { useQuery } from '@apollo/client';
import { GET_PRO } from '@gql/pros';
import { Box } from '@mui/material';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import OrganizationUserForm from './forms/OrganizationUserForm';

const OrganizationUserCreate = () => {
    const { id: companyId } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [selectedData, setSelectedData] = useState(null);

    const { data: proData, loading: loadingProData } = useQuery(GET_PRO, {
        variables: { proId: companyId },
        skip: !companyId,
    });

    const pro = proData?.getPro;

    if (loadingProData) {
        return <Box>Loading...</Box>;
    }

    if (!pro) {
        return <Box>Company not found</Box>;
    }

    return (
        <Box sx={{ width: '100%' }}>
            <OrganizationUserForm
                proId={pro._id}
                selectedData={selectedData}
                setIsActiveForm={(value) => {
                    if (value === '') {
                        // Navigate back to list when form is closed
                        navigate(`/companies/${companyId}/users`);
                    }
                }}
                setSelectedData={setSelectedData}
            />
        </Box>
    );
};

export default OrganizationUserCreate;
